<template>
  <div class="gp-main-body-content">
    <!-- <div class="row mb-2">
      <div class="col-6">
        <h2 class="flex-v-center typo-h3">Video Tutorial</h2>
      </div>
      <div class="col-6"></div>
    </div>-->
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "TutorialLayout",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions("tutorial", {
      fetchData: "tutorialGetPlaylists"
    }),
    onTabChangeHandler() {}
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .gfLoader {
    background-color: rgba(#000, 0.5) !important;
  }
}
</style>
